import { AUTH_URL } from './apiConfig';
import { fetchJsonWithAuth } from './authApi';

function dataOf(json) {
  return json?.data ?? json;
}

export async function getPaymentInvoice(id) {
  const normalizedId = String(id ?? '').trim();
  if (!normalizedId) throw new Error('Invoice id is required');
  return dataOf(await fetchJsonWithAuth(AUTH_URL, `/payments/invoice/${encodeURIComponent(normalizedId)}`));
}

